import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import './workerDetail.css';
import BASE_URL from "../context/AppConfig";
import IMG_URL from "../context/AppImgConfig";

const WorkerDetail = () => {
  const { workerId } = useParams();
  const [worker, setWorker] = useState(null);
  const [attendance, setAttendance] = useState([]);
  const [loading, setLoading] = useState(true);
  const token = localStorage.getItem("token");
  const [date, setDate] = useState("");

  useEffect(() => {
    const fetchData = async () => {
      try {
        
        const workerRes = await axios.get(`${BASE_URL}/worker/${workerId}/`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        const url = date
        ? `${BASE_URL}/attendance/${workerId}/?date=${date}`
        : `${BASE_URL}/attendance/${workerId}/`;

        const attendanceRes = await axios.get(url, {
          headers: { Authorization: `Bearer ${token}` },
        });
        console.log(workerRes.data);
        setWorker(workerRes.data);
        setAttendance(attendanceRes.data);
        setLoading(false);
      } catch (error) {
        console.error("Error fetching data", error);
      }
    };

    fetchData();
  }, [workerId,date]);

  if (loading) return <p className="text-center mt-4">Loading...</p>;

  return (
    <div className="container mt-5">
      <div className="worker">
      <div className="worker_header">
        <h2>Worker Detail: {worker?.name}</h2>
      </div>
      <div className="worker_body">
        <div className="worker_info">
          <p><strong>ID:</strong> {worker?.worker_id}</p>
          <p><strong>Job Role:</strong> {worker?.job_role}</p>
          <p><strong>Wage Type:</strong> {worker?.wage_type}</p>
          <p><strong>Work Site:</strong> {worker?.worksite}</p>
        </div>
      <div className="qr_code">
        <img
            src={`${IMG_URL}/${worker?.qr_code}`}
            alt="QR Code"
            className="img-fluid my-3"
            style={{ maxWidth: "200px" }}
          />
      </div>
      </div>
      </div>

<div className="container mt-4">
      <h3>Attendance Records</h3>
      <div className="mb-3">
        <label>Select Date:</label>
        <input
          type="date"
          className="form-control"
          value={date}
          onChange={(e) => setDate(e.target.value)}
        />
         {/* <button className="btn btn-primary mt-2" onClick={fetchData}>
          Filter
        </button>  */}
      </div>
      <table className="table table-bordered mt-3">
        <thead>
          <tr>
            
            <th>Date</th>
            <th>Check-In</th>
            <th>Check-Out</th>
            <th>Supervisor</th>
            <th>Overtime Hours</th>
            <th>Total Wage</th>
          </tr>
        </thead>
        <tbody>
          {attendance.map((att, index) => (
            <tr key={index}>
              
              <td>{att.date}</td>
              <td>{att.check_in_time ? new Date(att.check_in_time).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: false }) : "N/A"}</td>
<td>{att.check_out_time ? new Date(att.check_out_time).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: false }) : "N/A"}</td>

              <td>{att.supervisor || "N/A"}</td>
              <td>{att.is_overtime || 0}</td>
              <td>₹{att.total_wage}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
    </div>
  );
};

export default WorkerDetail;
